import styled from "styled-components";

export const Container = styled.div`
  min-height: 100%;
  min-height: 90vh;

  background-color: #18A0FB;
  position: relative;
  top: 0;
  padding-top: 4.5rem !important;
  z-index: 1;

  min-width: 18.75rem;
  width: 18.75rem;
  left:-18.75rem;
  transition: 350ms;

  overflow-y: auto; // Habilita scroll-down quando o tamanho exceder.

  ${(props) => {
    if (props.active){
      return(
        "left: 0; transition: 350ms;"
      )
    } 
  }}


  .sidebar{
    display: flex;
    flex-direction: column;
    padding: 0 10%;
    margin-top: 1rem;

   
  }

  .text-link {
    color: inherit;
    text-decoration: inherit;
  }

  .icon {
    height: 25px;
    width: 25px;
    color: #FFF;
    margin-top: 5px;
    vertical-align: middle;
    margin-right: 10px;
  }

  .icon.close{
    height: 40px;
    width: 40px;
    &:hover{
      cursor: pointer;
    }
  }

  span {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    line-height: 108%;
    color: #FFF;
    padding: 0.5rem 0;
  }

  .top-list span{
    text-align: center;
    display: flex;
    flex-direction: column;
    font-size: 1.125rem;
  }

  .top-list .title {
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: flex;
    span {
      font-size: 1.25rem;
    }
  }

  .sidebar ul{
    list-style: none;
    padding: 0;
  }

  .sidebar li {
    padding: 0.5rem 0;
    display: table;
  }

  .midle-list{
    border-style: solid none solid none;
    border-color: #FFF;
    border-width: 1px;

    span{
      font-size: 1.25rem;
    }
  }

  .midle-list .icon{
    vertical-align: middle;
    height: 100%;
    width: 20px;
    margin: 0 10px 5px 0;
  }

  .bottom-list{
    height: 100%;

    span{
      font-size: 1.125rem;
    }
  }

  @media screen and (max-width: 765px) {
    position: fixed;
    height: 100%;
  }
`

export const FloatButton = styled.div`

  &:hover{
    cursor:pointer;
  }
	position: fixed;
	width:60px;
	height:60px;
	top:5rem;
	left:2.5rem;
	background-color:#18A0FB;
	color:#FFF;
	border-radius:50%;
	text-align:center;
	box-shadow: 2px 2px 3px #999;
  z-index: 1;


  .icon{
    margin-top:18px;
    height: 20px;
    width: auto;
  }

  @media screen and (max-width: 576px) {
    left: 2vw;
  }

`